<template>
  <div class="company">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容-->
    <div class="company-content">
      <el-row type="flex" :gutter="10">
        <el-col :span="6" style="background-color: #ffffff">
          <el-card shadow="hover" class="box-card">
            <div slot="header" class="clearfix">
              <!--<span>{{$t("company.title")}}</span>-->
              <span>公司列表</span>
              <span
                class="i-icon"
                v-bind:style="{
                  display: userInfo.userInfo.adminFlag == 1 ? 'inline-block' : 'none',
                }"
              >
                <template v-for="(item, i) in menuButtonList">
                  <svg-icon
                    class="icon-img"
                    style="font-size: 16px; padding-left: 10px"
                    :key="i"
                    v-if="item.type == '0'"
                    :class="item.attributes.buttonStyle"
                    :title="item.label"
                    @click="chooseClick(item.attributes.buttonUrl, item)"
                    :icon-class="item.attributes.buttonStyle"
                  />
                  <!--<i-->
                  <!--  :key="i"-->
                  <!--  v-if="item.type == '0'"-->
                  <!--  :class="item.attributes.buttonStyle"-->
                  <!--  :title="item.label"-->
                  <!--  @click="chooseClick(item.attributes.buttonUrl,item)"-->
                  <!--&gt;</i>-->
                </template>
              </span>
            </div>
            <el-tree
              class="company-tree"
              :data="data"
              :props="defaultProps"
              :default-expand-all="false"
              highlight-current
              node-key="id"
              show-checkbox
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              ref="tree"
              v-bind:style="{ height: heightTree, 'overflow-y': 'auto' }"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span
                  :style="{ color: data.attributes.currentStatus == '1' ? '#ccc' : '#606266' }"
                  >{{ node.label }}</span
                >
              </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="18">
          <!--管理员-->
          <div v-if="userInfo.userInfo.adminFlag == 1">
            <el-tabs type="card" v-model="activeName" class="common-tab">
              <el-tab-pane :label="firstLabel" name="first">
                <div class="detail" v-if="!edit">
                  <departmentDetail
                    v-if="detail.type == 'department'"
                    :detail="detail"
                    :receiptClaimModeList="receiptClaimModeList"
                    :tableData="tableData"
                    :unitData="unitData"
                    ref="departmentDetail"
                  ></departmentDetail>
                  <companyDetail
                    v-else
                    :detail="detail"
                    :receiptClaimModeList="receiptClaimModeList"
                    :tableData="tableData"
                    ref="companyDetail"
                  ></companyDetail>
                </div>
                <div class="detail" v-else>
                  <editDepartment
                    v-if="detail.type == 'department'"
                    :detail="detail"
                    :receiptClaimModeList="receiptClaimModeList"
                    :tableData="tableData"
                    :unitData="unitData"
                    @getData="getData"
                    @setLoading="setLoading"
                    ref="editDepartment"
                  ></editDepartment>
                  <editCompany
                    v-else
                    :detail="detail"
                    :tableData="tableData"
                    :receiptClaimModeList="receiptClaimModeList"
                    @getData="getData"
                    @setLoading="setLoading"
                    ref="editCompany"
                  ></editCompany>
                </div>
                <!--底部操作按钮-->
                <div class="footer" v-if="edit">
                  <el-button :loading="load" @click="updateSure()" type="primary">{{
                    $t('dialog.confirm')
                  }}</el-button>
                  <el-button @click="edit = false">{{ $t('dialog.cancel') }}</el-button>
                </div>
              </el-tab-pane>
              <!-- <el-tab-pane :label="$t('company.system')" name="second">系统映射表</el-tab-pane> -->
              <el-tab-pane :label="$t('company.history')" name="third">
                <div class="detail">
                  <historyData ref="historyData"></historyData>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!--普通账号-->
          <div v-if="userInfo.userInfo.adminFlag == 2">
            <el-tabs type="card" v-model="activeName" class="common-tab">
              <!-- <el-tab-pane :label="firstLabel" name="first">
                <div class="detail">
                  <departmentDetail
                    v-if="detail.type == 'department'"
                    :detail="detail"
                    :tableData="tableData"
                    :unitData="unitData"
                    :flag="!edit"
                    ref="departmentDetail"
                  ></departmentDetail>
                  <companyDetail
                    v-else
                    :detail="detail"
                    :tableData="tableData"
                    :flag="!edit"
                    ref="companyDetail"
                  ></companyDetail>
                </div>
              </el-tab-pane> -->
              <el-tab-pane :label="$t('company.history')" name="third">
                <div class="detail">
                  <historyData ref="historyData"></historyData>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <addCompany
      v-on:getData="getData"
      :receiptClaimModeList="receiptClaimModeList"
      ref="addCompany"
    ></addCompany>
    <addDepartment
      v-on:getData="getData"
      :receiptClaimModeList="receiptClaimModeList"
      ref="addDepartment"
    ></addDepartment>
    <SiruiUpload
      v-on:getData="getData"
      :action="action"
      :data="importData"
      ref="siruiUpload"
    ></SiruiUpload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiUpload from '@/components/SiruiUpload';
  import companyDetail from '../components/detail/companyDetail';
  import departmentDetail from '../components/detail/departmentDetail';
  import addCompany from '../components/addModal/addCompany';
  import addDepartment from '../components/addModal/addDepartment';
  import editCompany from '../components/edit/editCompany';
  import editDepartment from '../components/edit/editDepartment';
  import historyData from '../components/detail/historyData';

  export default {
    name: 'company',
    components: {
      SiruiSearch,
      SiruiUpload,
      companyDetail,
      departmentDetail,
      addCompany,
      addDepartment,
      editCompany,
      editDepartment,
      historyData,
    },
    data() {
      return {
        activeName: 'first',
        query: {
          createCompanyName: null,
          searchCompanyCode: null,
          currentStatus: null,
        },
        data: [],
        defaultProps: {
          children: 'children',
          label: function (data) {
            return data.label;
          },
        },
        detail: {},
        menuButtonList: [],
        tableData: [],
        unitData: [],
        load: false,
        edit: false,
        //历史记录的类型
        historyData: [],
        //当前选中的第几级
        level: 0,
      };
    },
    computed: {
      action() {
        return API.IMPORT_COMPANY_API;
      },
      firstLabel: {
        get: function () {
          if ('department' == this.detail.type) {
            return this.$t('company.departmentInfo');
          } else {
            return this.$t('company.companyInfo');
          }
        },
      },
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'createCompanyName',
            name: this.$t('company.search.companyName'),
            type: 'input',
            placeholder: this.$t('company.search.companyNamePlaceholder'),
          },
          {
            prop: 'searchCompanyCode',
            name: this.$t('company.search.companyCode'),
            type: 'input',
            placeholder: this.$t('company.search.companyCodePlaceholder'),
          },
          {
            prop: 'currentStatus',
            name: this.$t('company.search.status'),
            type: 'select',
            placeholder: this.$t('company.search.statusPlaceholder'),
            options: [
              {
                label: '已禁用',
                value: '1',
              },
              {
                label: '已生效',
                value: '0',
              },
            ],
          },
        ];
      },
      heightTree() {
        return window.innerHeight - 235 + 'px';
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        receiptClaimModeList() {
          return this.$baseRequest.getDictListByType('receiveClaimPattern');
        },
        lang: (state) => state.lang,
      }),
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          belongTenantCode: this.userInfo.userInfo.tenantCode,
          access_token: this.userInfo.userInfo.access_token,
          lang: this.lang.language,
        };
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getButtonList();
        this.getData();

        if (this.userInfo.userInfo.adminFlag == 2) this.activeName = 'third';
      });
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      getData() {
        this.detail = {};
        this.historyData = [];
        this.edit = false;
        this.load = false;
        this.tableData = [];
        this.unitData = [];
        const query = this.$refs.siruiSearch.query;
        query.tenantCode = this.userInfo.userInfo.tenantCode;
        query.adminFlag = this.userInfo.userInfo.adminFlag;
        if (this.$route.params.name) {
          query.createCompanyName = this.$route.params.name;
        }
        this.$axios.post(API.LIST_COMPANY_API, query).then((res) => {
          if (0 == res.data.code) {
            this.data = res.data.data;
            if (this.$route.query.createCompanyCode && this.userInfo.userInfo.adminFlag == 1) {
              //设置默认选中
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.$route.query.createCompanyCode);
                //调用查询详情的方法
                this.handleNodeClick(this.$refs.tree.getCurrentNode());
              });
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //搜索
      searchBtnClick() {
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.getData();
      },
      chooseClick(type) {
        console.log(type);
        if (type == 'add') {
          if (this.level > 4) {
            this.$message({
              showClose: true,
              message: this.$t('company.addError'),
              type: 'error',
            });
            return;
          }
          this.addCompany();
        } else if (type == 'edit') {
          this.editCompany();
        } else if (type == 'forbid') {
          this.fotbidCompany();
        } else if (type == 'lift') {
          this.liftCompany();
        } else if (type == 'import') {
          this.importCompany();
        } else if (type == 'export') {
          this.exportCompany();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      //新增公司或部门
      addCompany() {
        if (this.detail.type == 'company') {
          this.detail.superiorUnitCode = this.detail.createCompanyCode;
          this.detail.superiorUnit = this.detail.createCompanyName;
          this.$refs.addDepartment.openDialog(true, this.detail);
        } else if (this.detail.type == 'department') {
          this.detail.superiorUnitCode = this.detail.createDepartmentCode;
          this.detail.superiorUnit = this.detail.createDepartmentName;
          this.$refs.addDepartment.openDialog(true, this.detail);
        } else {
          this.$refs.addCompany.openDialog(true, this.detail);
        }
      },
      //修改公司或部门
      editCompany() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.editTips'),
            type: 'error',
          });
          return;
        }
        this.edit = true;
        this.activeName = 'first';
        if (this.detail.type == 'department') {
          this.$nextTick(() => {
            this.$refs.editDepartment.initData();
          });
        } else {
          this.$nextTick(() => {
            this.$refs.editCompany.initData();
          });
        }
      },
      //禁用公司或部门
      fotbidCompany() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.fotbidNoTips'),
            type: 'error',
          });
          return;
        }
        if (this.detail.currentStatus == '1') {
          this.$message({
            showClose: true,
            message: this.$t('company.fotbidTips'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction(this.$t('confirm.forbid'), this.$t('confirm.forbidContent'))
          .then(() => {
            const params = {
              currentStatus: '1',
              version: this.detail.version,
            };
            this.loading.startLoading();
            let API_STATUS = '';
            if (this.detail.type == 'company') {
              params.createCompanyCode = this.detail.createCompanyCode;
              API_STATUS = API.UPDATE_STATUS_API;
            } else {
              params.createDepartmentCode = this.detail.createDepartmentCode;
              params.belongCompanyCode = this.detail.belongCompanyCode;
              API_STATUS = API.UPDATE_DEPART_STATUS_API;
            }
            this.$axios.post(API_STATUS, params).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.getData();
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //启用公司或部门
      liftCompany() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.liftNoTips'),
            type: 'error',
          });
          return;
        }
        if (this.detail.currentStatus == '0') {
          this.$message({
            showClose: true,
            message: this.$t('company.liftTips'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction(this.$t('confirm.lift'), this.$t('confirm.liftContent'))
          .then(() => {
            const params = {
              currentStatus: '0',
              version: this.detail.version,
            };
            let API_STATUS = '';
            if (this.detail.type == 'company') {
              params.createCompanyCode = this.detail.createCompanyCode;
              API_STATUS = API.UPDATE_STATUS_API;
            } else {
              params.createDepartmentCode = this.detail.createDepartmentCode;
              params.belongCompanyCode = this.detail.belongCompanyCode;
              API_STATUS = API.UPDATE_DEPART_STATUS_API;
            }
            this.loading.startLoading();
            this.$axios.post(API_STATUS, params).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.getData();
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //导入公司或部门
      importCompany() {
        this.$refs.siruiUpload.openDialog(true);
      },
      //导出公司或部门
      exportCompany() {
        let checkedList = this.$refs.tree.getCheckedNodes();
        this.loading.startLoading();
        let list = [];
        for (var i = 0; i < checkedList.length; i++) {
          if (checkedList[i].type == 'company') {
            list.push(checkedList[i].id);
          }
        }
        this.$axios
          .post(API.EXPORT_COMPANY_API, {
            companyNoList: list,
          })
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              window.location.href = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      //选择公司或部门
      handleNodeClick(data, node) {
        this.level = node.level;
        this.tableData = [];
        this.unitData = [];
        this.edit = false;
        let API_DETAIL = '';
        if (data.type == 'department') {
          API_DETAIL = API.GET_DEPARTMENT_DETAIL_API;
        } else {
          API_DETAIL = API.GET_COMPANY_DETAIL_API;
        }
        //管理员可以查看详情
        if (this.userInfo.userInfo.adminFlag == 1) {
          this.$axios.get(API_DETAIL + '/' + data.id).then((res) => {
            if (0 == res.data.code) {
              if (data.type == 'department') {
                //历史记录
                this.getHistoryData(
                  'department',
                  res.data.data.departmentDetail.createDepartmentCode
                );
                //部门详情
                this.detail = res.data.data.departmentDetail;
                this.detail.type = data.type;
                this.detail.currentStatusName =
                  res.data.data.departmentDetail.currentStatus == '0' ? '已生效' : '已禁用';
                //上级单位
                this.unitData = [res.data.data.company || res.data.data.department];
                this.unitData[0].superiorUnitCode = res.data.data.company
                  ? res.data.data.company.createCompanyCode
                  : res.data.data.department.createDepartmentCode;
                //所属控制范围
                this.tableData = res.data.data.controlAreaList;
              } else {
                //历史记录
                this.getHistoryData('company', res.data.data.company.createCompanyCode);
                //公司详情
                this.detail = res.data.data.company;
                this.detail.type = data.type;
                this.detail.currentStatusName =
                  res.data.data.company.currentStatus == '0' ? '已生效' : '已禁用';
                this.tableData = res.data.data.department;
              }
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.detail.type = data.type;
          if (data.type == 'department') {
            //历史记录
            this.getHistoryData('department', data.id);
          } else {
            //历史记录
            this.getHistoryData('company', data.id);
          }
        }
      },
      getHistoryData(type, code) {
        this.$refs.historyData.getData(type, code);
      },
      setLoading(obj) {
        this.load = obj.loading;
        if (obj.edit) {
          this.edit = obj.edit;
        }
      },
      //修改保存
      updateSure() {
        if (this.detail.type == 'department') {
          this.$refs.editDepartment.addSure(this.load);
        } else {
          this.$refs.editCompany.addSure(this.load);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .company-content {
    margin-top: 10px;
  }
  .i-icon {
    float: right;
    i {
      cursor: pointer;
      margin: 0 2px;
    }
  }
  .footer {
    background: #fff;
    height: 70px;
    line-height: 70px;
    text-align: center;
    margin-top: 10px;
  }
</style>
<style lang="scss"></style>
